export default "__VITE_ASSET__DgjEvv_1__"